// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"203547ca","404":"db065f0b","483":"09c2cfc2","787":"782b1036"}[chunkId] + ".chunk.js";
};